module.exports = __webpack_public_path__ + "img/admin-notifications.26ae02b9.png";